import defaultState from './state'
import Vue from 'vue'
export default {
  setMerchants: (state, payload) => {
    state.currentPage === 1
      ? (state.merchants = payload)
      : state.merchants.push(...payload)
  },
  setCurrentMerchant: (state, payload) => {
    state.currentMerchant = payload
  },
  updateMerchant: (state, payload) => {
    const { id } = payload
    const merchantToUpdateIndex = state.merchants.findIndex(el => el.id === id)
    merchantToUpdateIndex >= 0
      ? state.merchants.splice(merchantToUpdateIndex, 1, payload)
      : state.merchants.push(payload)
  },
  setActivityGroups: (state, payload) => {
    state.currentPage === 1
      ? (state.activityGroups = payload)
      : state.activityGroups.push(...payload)
  },
  updateActivityGroup: (state, payload) => {
    const { id } = payload
    const activityGroupToUpdateIndex = state.activityGroups.findIndex(
      el => el.id === id
    )
    activityGroupToUpdateIndex >= 0
      ? state.activityGroups.splice(activityGroupToUpdateIndex, 1, payload)
      : state.activityGroups.push(payload)
  },

  setTotalItems: (state, payload) => {
    state.setTotalItems = payload
  },
  incrementCurrentPage: state => state.currentPage++,
  setLastPage: (state, payload) => {
    state.lastPage = payload
  },
  setCurrentActivityGroup: (state, payload) => {
    state.currentActivityGroup = payload
  },
  setIsCalling: (state, payload) => {
    state.isCalling = payload
  },
  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }
}
